import { Navigate, Outlet } from "react-router-dom";
import { useSuperadminSession } from "@/hooks/use-auth";
import { AuthLoading } from "./auth-loading";

/** Route guard for /superadmin/* — probes /api/superadmin/requests. */
export function RequireSuperadmin() {
  const { data: ok, isLoading } = useSuperadminSession();

  if (isLoading) return <AuthLoading />;
  if (!ok) return <Navigate to="/superadmin/login" replace />;
  return <Outlet />;
}
